import React from "react";
import { StageSelect } from "../components/StageSelect/StageSelect";
import { Page } from "../components/Page/Page";

export function StageSelectPage(): JSX.Element {
  return (
    <Page>
      <StageSelect />
    </Page>
  );
}
